/** Bumped whenever a refresh from the server changes allowed_domains in localStorage. */
let domainListRevision = 0;

export function getDomainListRevision() {
    return domainListRevision;
}

export function bumpDomainListRevision() {
    domainListRevision += 1;
    window.dispatchEvent(new CustomEvent('domains:updated'));
}
